<template>
    <div>
        <header>
            <div class="header">
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-md-4 d-flex align-items-center">
                            <template v-if="!user">
                                <div class="w-40">
                                    <span class="txt-h-6 txt-white">
                                        Seja assinante!
                                    </span>
                                    <p class="txt-h-6 txt-size-12 txt-white mb-2">
                                        Tenha acesso a todas as ferramentas do Sollicita.
                                    </p>
                                </div>
                                <div>
                                    <button class="btn btn-yellow px-4" @click="showModalExperimenteGratis = !showModalExperimenteGratis">
                                        Experimente grátis!
                                    </button>
                                </div>
                            </template>

                        </div>
                        <div class="col-12 col-md-4 my-2 my-sm-0 d-flex justify-content-center align-items-center">
                            <router-link :to="{name:'Home'}">
                                <img class="logo-sollicita" :src="logo" />
                            </router-link>
                        </div>
                        <div class="col-12 col-md-4 d-flex flex-column align-items-center">
                            <template v-if="user != null && user != undefined">
                                <div class="d-flex flex-wrap flex-column position-relative w-100 h-100 justify-content-center align-items-end">


                                    <div class="position-relative" style="min-width: 250px; min-height: 65px">
                                        <div :class="'box-dados-usuario ' + (flDadosUsuario ?'active':'' )">

                                            <div class="box-dados-usuario-titulo" @click="flDadosUsuario = !flDadosUsuario">
                                                <template v-if="user.usuario">
                                                    <ImgDefault :nome="user.usuario.nmUsuario" :size="1" :borda="true"></ImgDefault>
                                                </template>


                                                <span class="ms-3 txt-p txt-size-20" v-if="user.usuario != null">Olá, <b>{{primeiroNome}}</b></span>
                                                <span class="ms-3 txt-p c-pointer txt-size-20" data-bs-toggle="dropdown" aria-expanded="false"><i class="fas fa-caret-down"></i></span>
                                            </div>



                                            <div class="box-dados-usuario-conteudo ">
                                                <p class="txt-p txt-blue-2 txt-w-5 px-3 c-pointer mb-1" @click="showModalDados = !showModalDados"><i class="fas fa-user me-2"></i> Meus dados</p>
                                                <p class="txt-p txt-blue-2 txt-w-5 px-3 c-pointer mb-1" @click="showModalSenha = !showModalSenha"><i class="fas fa-key me-2"></i> Mudar senha</p>

                                                <div class="bg-blue-2 rounded py-2 px-3">
                                                    <p class="txt-p txt-white txt-w-5 c-pointer mb-1" @click="mural"><i class="icon-mural"></i> Mural</p>
                                                    <p class="txt-p txt-white txt-w-5 c-pointer mb-1" @click="ferramentas"><i class="fas fa-tools"></i> Ferramentas</p>
                                                    <!--<p class="txt-p txt-white txt-w-5 c-pointer mb-1" @click="leiComentada"><i class="icon-lei-comentada"></i> Lei comentada</p>-->
                                                    <p class="txt-p txt-white txt-w-5 c-pointer mb-1" @click="livraria"><i class="icon-ebook"></i> Livraria</p>

                                                </div>
                                                <!-- SUPORTE -->
                                                <template v-if="user.usuario.tpPessoa == 'J' && user.usuario.flCortesia != 'Sim'">
                                                    <a class="txt-p txt-blue-2 txt-w-5 px-3 c-pointer mb-1" v-if="user.usuario.idContrato != null && user.usuario.idPessoa != null"
                                                       :href="urlSuporte+'p_idContrato='+user.usuario.idContrato+'&amp;p_idPessoa='+user.usuario.idPessoa" target="_blank">
                                                        <i class="fas fa-headset me-2"></i>
                                                        <span>Falar com o suporte</span>
                                                    </a>
                                                </template>

                                                <p class="txt-p txt-blue-2 txt-w-5 px-3 c-pointer mb-2" @click="sair"><i class="fas fa-sign-out-alt me-2"></i> Sair</p>

                                            </div>

                                        </div>
                                    </div>

                                    <div class="box-acesso-rapido d-flex">
                                        <div class="item-box item-box-start py-2 px-3 " id="popover-target-1" @click="mural">
                                            <p class="d-flex txt-p txt-white txt-w-5 c-pointer mb-0"><i class="icon-mural"></i></p>
                                        </div>
                                        <b-popover target="popover-target-1" triggers="hover" placement="top">
                                            <span class="txt-h-6 txt-size-12 txt-w-8 txt-blue-1">Meu Mural</span>
                                        </b-popover>
                                        <div class="item-box py-2 px-3 " id="popover-target-2" @click="ferramentas">
                                            <p class="d-flex txt-p txt-white txt-w-5 c-pointer mb-0"><i class="fas fa-tools"></i></p>
                                        </div>
                                        <b-popover target="popover-target-2" triggers="hover" placement="top">
                                            <span class="txt-h-6 txt-size-12 txt-w-8 txt-blue-1">Ferramentas</span>
                                        </b-popover>

                                        <div class="item-box py-2 px-3 " id="popover-target-3" @click="livraria">
                                            <p class="d-flex txt-p txt-white txt-w-5 c-pointer mb-0"><i class="icon-ebook"></i></p>
                                        </div>
                                        <b-popover target="popover-target-3" triggers="hover" placement="top">
                                            <span class="txt-h-6 txt-size-12 txt-w-8 txt-blue-1">Livraria</span>
                                        </b-popover>
                                        <div class="item-box item-box-end py-2 px-3 ">
                                            <p class="d-flex txt-p txt-white txt-w-5 c-pointer mb-0" @click="sair">Sair</p>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="row w-100">
                                    <form class="col-8">
                                        <div class="mb-1">
                                            <input class="w-100 input-text" type="text" placeholder="Usuário" v-model="userLogin.login" required />
                                        </div>
                                        <div class="">
                                            <input class="w-100 input-text" type="password" name="senha" value="" placeholder="Senha" v-model="userLogin.password" v-on:keyup.enter="entrar" required />
                                        </div>

                                    </form>
                                    <div class="col-4 d-flex align-items-end">
                                        <button class="btn btn-yellow-outline w-100" type="button" @click="entrar">
                                            Entrar
                                        </button>
                                    </div>
                                </div>
                                <div class="row w-100">
                                    <div class="col-8">
                                        <div class="row">
                                            <div class="col-6">
                                                <a class="txt-h-6 txt-size-10 txt-white c-pointer" href="javascript:void(0)" @click="showModalEsqueciSenha = !showModalEsqueciSenha">Esqueci minha senha</a>
                                            </div>
                                            <div class="col-6 text-end">
                                                <a class="txt-h-6 txt-size-10 txt-white c-pointer" href="javascript:void(0)" @click="autoatendimento">Autoatendimento</a>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>

            <div class="navegacao">
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-md-12 d-flex align-items-center justify-content-center">
                            <div class="d-flex flex-wrap">
                                <template v-for="(item) in navegacao">
                                    <router-link v-if="item.nome == 'HOME'" :key="item.id"
                                                 :to="{name:'Home'}" :class="'item-navegacao txt-p txt-size-14 txt-white mx-2 c-pointer ' + (subIsActive(item) ? 'navegacao-active':'')">
                                        {{item.nome}}
                                    </router-link>
                                    <template v-else-if="item.nome == 'AO VIVO'">
                                        <router-link v-if="aovivo" :key="item.id"
                                                     :to="{name:'AoVivo'}" :class="'item-navegacao txt-p txt-size-14 txt-white mx-2 ao-vivo c-pointer '+(subIsActive(item) ? 'navegacao-active':'')">
                                            AO VIVO
                                        </router-link>
                                    </template>
                                    <router-link v-else :key="item.id"
                                                 :to="{name:'PesquisaNoticia', query:{idCategoria:item.idCategoria}}" :class="'item-navegacao txt-p txt-size-14 txt-white mx-2 c-pointer '+(subIsActive(item) ? 'navegacao-active':'')">
                                        {{item.nome}}
                                    </router-link>
                                </template>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </header>

        <MudarSenha :showModal="showModalSenha"></MudarSenha>
        <MeusDados :showModal="showModalDados"></MeusDados>
        <EsqueciMinhaSenha :showModal="showModalEsqueciSenha"></EsqueciMinhaSenha>
        <ExperimenteGratis :showModal="showModalExperimenteGratis"></ExperimenteGratis>

        <ModalTransmissao :showModal="showModalTransmissao" :trasmissao="aovivo"></ModalTransmissao>

        <ModalMarketing></ModalMarketing>
        <ModalNps v-if="user != null"></ModalNps>
    </div>
</template>

<script>
    import logo from '@/assets/img/Logo.png';
    import ImgDefault from '@/components/ImgDefault'
    import MudarSenha from '@/components/MudarSenha'
    import MeusDados from '@/components/MeusDados'
    import EsqueciMinhaSenha from '@/components/EsqueciMinhaSenha'
    import ModalTransmissao from '@/components/ModalTransmissao'
    import ModalMarketing from '@/components/ModalMarketing'
    import ModalNps from '@/components/ModalNps'
    import ExperimenteGratis from '@/components/ExperimenteGratis'
        
    import { urlApi, avisoErro, urlMural, urlFerramentas, urlPeriodicos, urlSuporte  } from '@/config/global'
    import axios from 'axios'
    import $ from 'jquery'

    export default {
        name: 'Header',
        components: { ImgDefault, EsqueciMinhaSenha, MudarSenha, MeusDados, ModalTransmissao, ModalMarketing, ModalNps, ExperimenteGratis },
        computed: {
            user() {
                return this.$store.state.user
            },

            primeiroNome() {
                if (this.user && this.user.usuario) {
                    if (this.user.usuario.nmUsuario) {
                        return this.user.usuario.nmUsuario.split(" ")[0]
                    } else {
                        return "";
                    }
                } else {
                    return "";
                }
                
            },
        },
        data: function () {
            return {
                logo,

                userLogin: {
                    login: "",
                    password: "",
                },

                navegacao: [
                    { id: 1, nome: "HOME", route: "Home"},
                    { id: 2, nome: "LEI 14.133/21", idCategoria: 87, route: "PesquisaNoticia"},
                    { id: 3, nome: "CORONAVÍRUS", idCategoria: 80, route: "PesquisaNoticia"},
                    { id: 4, nome: "ARTIGOS", idCategoria: 40, route: "PesquisaNoticia"},
                    { id: 5, nome: "NOTÍCIAS NP", idCategoria: 73, route: "PesquisaNoticia"},
                    { id: 6, nome: "ESTATAIS", idCategoria: 84, route: "PesquisaNoticia"},
                    { id: 7, nome: "FISCALIZAÇÃO", idCategoria: 4, route: "PesquisaNoticia"},
                    { id: 8, nome: "GOVERNANÇA", idCategoria: 43, route: "PesquisaNoticia"},
                    { id: 9, nome: "LEGISLAÇÃO", idCategoria: 2, route: "PesquisaNoticia"},
                    { id: 10, nome: "LICITAÇÃO", idCategoria: 9, route: "PesquisaNoticia"},
                    { id: 11, nome: "AO VIVO", route: "AoVivo"},
                ],

                aovivo: null,

                flDadosUsuario: false,
                showModalDados: false,
                showModalSenha: false,
                showModalEsqueciSenha: false,

                flgModalTransmissao: false,
                showModalTransmissao: false,
                showModalExperimenteGratis: false,
                urlSuporte: urlSuporte,
            }
        },
        methods: {

            subIsActive(input) {
                
                let name = this.$route.name.split('-')[0];
                
                if (name == 'PesquisaNoticia') {
                    if (input.idCategoria == undefined) {
                        return false;
                    }
                    let idCategoria = parseInt(this.$route.query.idCategoria);
                    return idCategoria == input.idCategoria;
                } else {
                    return name.toLowerCase() == input.route.toLowerCase();
                }
                
            },

            entrar(event) {
                event.preventDefault();
                if (this.checkForm()) {
                    let $this = this;
                    axios.post(`${urlApi}/Auth/signin`, this.userLogin)
                        .then(res => {
                            if (res.data.token.authenticated) {
                                res.data.token.usuario = res.data.usuario;
                                res.data.token.usuario.idContrato = res.data.idContrato;
                                res.data.token.usuario.tpPessoa = res.data.tpPessoa;
                                res.data.token.usuario.flCortesia = res.data.flCortesia;
                                $this.$store.commit('setUser', res.data.token);
                                $(".whatsapp-link").show();
                            } else {
                                avisoErro("Erro ao realizar login.");
                            }
                        })
                        .catch(function () {
                            avisoErro("Login e/ou senha inválidos.");
                        })
                }

                return false;
            },


            checkForm() {
                var form = document.querySelector('form')
                if (!form.checkValidity()) {
                    var tmpSubmit = document.createElement('button')
                    form.appendChild(tmpSubmit)
                    tmpSubmit.click()
                    form.removeChild(tmpSubmit)

                    return false;
                }

                return true;
            },

            autoatendimento() {
                document.getElementById('blip-chat-icon').click();
            },

            sair() {
                let $this = this;
                axios.get(`${urlApi}/Auth/revoke`)
                    .then(function () {
                        $this.$store.commit('setUser', null)
                        location.reload();
                    })
                    .catch(res => {
                        if (res.response.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },

            verificaAoVivo() {
                let $this = this;
                axios.get(`${urlApi}/AoVivo/VerificaTransmissaoAoVivo`, { params: { take: 5, index: 0 } })
                    .then(res => {
                        if (res.data.success) {
                            $this.dadosAoVivo = null;
                            if (res.data.data.rows != null) {
                                var aovivo = res.data.data.rows[0];
                                $this.aovivo = aovivo;
                                $this.$store.commit('setAoVivo', res.data.data.rows[0]);

                                if (aovivo.flAtivo == 'Sim' && !$this.flgModalTransmissao) {
                                    // exibe modal de transmissão
                                    $this.flgModalTransmissao = true;
                                    if ($this.$route.name != 'AoVivo') {
                                        $this.showModalTransmissao = !$this.showModalTransmissao;
                                    }
                                    

                                }
                            }
                        } else {
                            console.log("Não foi possível carregar a trasmissão ao vivo");
                            $this.dadosAoVivo = null;
                        }
                    })
                    .catch(function () {
                        console.log("Não foi possível carregar a trasmissão ao vivo");
                        $this.dadosAoVivo = null;
                    });
            },

            mural() {
                var url = urlMural + 'AutenticacaoAutomatica?token=' + this.user.accessToken + '&refreshTokenWeb=' + this.user.refreshTokenWeb;
                window.location.href = encodeURI(url);
            },

            leiComentada() {
                var url = urlFerramentas + 'AutenticacaoAutomatica?route=LeiComentada&token=' + this.user.accessToken + '&refreshTokenWeb=' + this.user.refreshTokenWeb;
                window.location.href = encodeURI(url);
            },

            livraria() {
                var url = urlPeriodicos + 'AutenticacaoAutomatica?token=' + this.user.accessToken + '&refreshTokenWeb=' + this.user.refreshTokenWeb + '&route=Ebooks';
                window.location.href = encodeURI(url);
            },

            ferramentas() {
                var url = urlFerramentas + 'AutenticacaoAutomatica?token=' + this.user.accessToken + '&refreshTokenWeb=' + this.user.refreshTokenWeb;
                window.location.href = encodeURI(url);
            },
        },
        mounted: function () {
            this.verificaAoVivo();

            if (this.user) {
                $(".whatsapp-link").show();
            }
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    header {
    }

    .header {
        background: color('blue','2');
        padding: 20px 0;
    }

    .logo-sollicita{
        max-height: 91px;
        
    }

    .navegacao {
        background: color('blue','1');

        .item-navegacao {
            padding: 15px 0 10px 0;
        }
    }

    .navegacao-active {
        border-bottom: 5px solid #FFF;
    }

    .ao-vivo::after {
        content: "\A";
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #FF0000;
        display: inline-block;
        margin: 0 5px;
        filter: blur(2px);
    }

    .box-dados-usuario {
        /*padding: 10px;*/
        color: #FFF;
        z-index: 999;
        min-height: 65px;

        .box-dados-usuario-conteudo {
            display: none;
        }

        .box-dados-usuario-titulo {
            cursor: pointer;
            display: flex;
            align-items: center;
            background-color: color('blue','1');
            padding: 10px;
            border-radius: 10px 10px 0 10px;

            img {
                width: 45px;
                height: 45px;
                border-radius: 50%;
            }
        }
    }

    .box-dados-usuario.active {
        position: absolute;
        top: 0;
        background-color: #FFF;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        color: color('blue','2');
        padding: 10px;

        .box-dados-usuario-titulo {
            background-color: #FFF;
            padding: 0;
        }

        .box-dados-usuario-conteudo {
            display: block;
            margin-top: 15px;

            p:hover {
                border-radius: 5px;
                background-color: color('grey','3');
                color: color('blue','2') !important;
            }
        }
    }

    .box-acesso-rapido {
        .item-box {
            background: #FBBC0D;
            display: flex;
            align-items: center;
        }

        .item-box-start {
            background: #FBBC0D;
            border-radius: 10px 0 0 10px;
        }

        .item-box-end {
            background: #153D57;
            border-radius: 0 10px 10px 0;
        }
    }
</style>

